<template>
	<b-modal :id="`DispenserTo-${key}`" :title="title" no-close-on-backdrop hide-footer>
		<div v-if="!showForm">
			<FormulateForm name="formDispenseTo" v-model="form" @submit="save">
				<div class="row row-xs">
					<div class="col-12 col-md-6 mb-2">
						<FormulateInput label="Nombre" name="dispensedToName" validation-name="Nombre" validation="required" />
					</div>
					<div class="col-12 col-md-6 mb-2">
						<FormulateInput label="Apellido" name="dispensedToLastname" validation-name="Apellido" validation="required" />
					</div>
				</div>

				<FormulateInput type="identification" label="Documento de identidad" name="dispensedToDocument" validation-name="Documento de identidad" validation="optional|^documentID" />

				<div class="row row-xs">
					<div class="col-12 col-md-6 mb-2">
						<FormulateInput
							label="País"
							validation-name="País"
							name="dispensedToAddressCountry"
							:options="countries"
							type="selectSearch"
							option-value="id"
							option-text="name"
							placeholder="Seleccione un país"
							:disabled="loadingCountries"
						/>
						<div class="formulate-input-help " v-if="loadingCountries">Cargando paises...</div>
					</div>
					<div class="col-12 col-md-6 mb-2">
						<FormulateInput label="Ciudad" name="dispensedToAddressCity" validation-name="Ciudad"  />
					</div>
				</div>

				<FormulateInput label="Calle número, etc..." name="dispensedToAddressStreet" validation-name="Ciudad" help="Dirección (calle, número, apartamento, etc...)" />

				<div class="d-flex justify-content-between mt-4">
					<FormulateInput type="button" data-ghost @click="close()">Cancelar</FormulateInput>
					<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
					<FormulateInput type="submit" label="Confirmar" v-else />
				</div>
			</FormulateForm>
		</div>
	</b-modal>
</template>

<script>
import gql from "graphql-tag"
export default {
	name: "DispenseToModalForm",
	components: {},
	data() {
		return {
			title: "Entregar a:",
			form: {
				dispensedToName: null,
				dispensedToLastname: null,
				dispensedToDocument: {
					type: "UY",
					number: null
				},
				dispensedToAddressCountry: "226",
				dispensedToAddressCountryName: "Uruguay",
				dispensedToAddressCity: null,
				dispensedToAddressStreet: null
			},
			countries: [],
			showForm: false,
			loadingCountries: false,
			key: Math.random()
		}
	},
	methods: {
		async open() {
			await this.fetchData()
			this.$bvModal.show(`DispenserTo-${this.key}`)
		},

		
		close() {
			this.id = null
			this.$bvModal.hide(`DispenserTo-${this.key}`)
		},

		save() {
			const selectedCountry = this.countries.find(c => parseInt(c.id) == this.form.dispensedToAddressCountry)
			this.form.dispensedToAddressCountryName = selectedCountry.name

			this.$emit("upserted", this.form)
			this.close()
		},

		fetchData() {
			this.loadingCountries = true
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.countries = data.countries
					this.loadingCountries = false
				})
				.catch(err => {
					console.log(err)
					this.loadingCountries = false
				})
		}
	}
}
</script>

<style></style>
